import { render, staticRenderFns } from "./GeometryViewer.vue?vue&type=template&id=5c99b8b0&scoped=true&"
import script from "./GeometryViewer.vue?vue&type=script&lang=ts&"
export * from "./GeometryViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c99b8b0",
  null
  
)

export default component.exports